<template>
    <button @click.prevent="$emit('toggleView', 'cart')" class="c-overlay__notebook__tools__link">
        <svg aria-hidden="true" focusable="false" class="o-ico c-overlay__notebook__tools__link__icon">
            <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=2024#arrow-left"></use>
        </svg>
        Retour
    </button>
    <div class="o-spacer-sm"></div>
    <div class="o-flex -flex-direction-column -flex-middle -flex-grow-1 -flex-overflow-auto -flex-width-100p">
        <div class="o-form -form-dark">
            <div class="o-flex -flex-direction-column">
                <div class="o-form__group">
                    <label for="user" class="o-label sr-only">
                        Nom d'utilisateur
                    </label>
                    <input class="o-input" type="text" id="user" v-model="username" placeholder="Nom d'utilisateur" required>
                </div>
                <div class="o-form__group">
                    <label for="email" class="o-label sr-only">
                        Courriel
                    </label>
                    <input class="o-input" type="email" id="email" v-model="email" placeholder="Courriel" required>
                </div>
                <div class="o-form__group">
                    <label for="password" class="o-label sr-only">
                        Mot de passe
                    </label>
                    <input class="o-input" type="password" id="password" v-model="password" placeholder="Mot de passe" required>
                </div>
                <div class="o-form__group">
                    <label for="password-confirm" class="o-label sr-only">
                        Confirmer le mot de passe
                    </label>
                    <input class="o-input" type="password" id="password-confirm" v-model="password2" placeholder="Confirmer le mot de passe" required>
                </div>
                <div v-if="error" class="o-alert -alert-error">
                    {{ error }}
                </div>
                <div class="o-flex -flex-space-between -flex-middle">
                    <button class="c-overlay__notebook__button__register" @click.prevent="$emit('toggleView', 'login')">Se connecter</button>
                    <button @click.prevent="register()" class="c-overlay__notebook__button__login">
                        S'enregistrer
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'CarnetRegister',
    data() {
        return {
            username: '',
            email: '',
            password:'',
            password2:'',
            subscribe: false,
            error: ''
        }
    },
    mounted() {
    },
    methods: {
        register() {
            if (this.password != this.password2) {
                this.error = 'Les mots de passe ne correspondent pas.';
                return;
            }

            fetch(WPURLS.ajax_url+'?action=carnet_ajaxregister',
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        username: this.username,
                        email: this.email,
                        password: this.password,
                        subscribe: this.subscribe
                    })
                }
            )
            .then(response => response.json())
            .then(data => {
                if (data.loggedin) {
                    this.$emit('toggleView', 'cart');
                    this.emitter.emit('getCart', 'cart');
                } else {
                    this.error = data.message;
                }
            })
            .catch((error) => {
                this.error = data.message;
            });
        }
    }
}
</script>